import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Textarea } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
import Playground from '@components/Playground';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "textarea"
    }}>{`Textarea`}</h1>
    <p>{`Used for accepting loger text`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Text>
    import {'{ Textarea }'} from '@cleartrip/bento'
  </Sandbox.Text>
    </Sandbox>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={1} __code={''} __scope={{
      props,
      DefaultLayout,
      Textarea,
      Sandbox,
      Playground,
      DefaultLayout,
      _frontmatter
    }} code="<Textarea />" scope={{
      Textarea
    }} mdxType="Playground" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      